export const PAYPAL_CLIENT_ID =
  "AWxqkOBLUryng0gdoMid0Rw4k6p73b5k7hmYHNtr13MGAr6OVODrGR8mh456sQHm-mV-6pu6sgMSb8KJ";

export const GIVING_PRESET_AMOUNTS = ["10", "25"];
